<template>
  <asc-dialog
    text="Duplicate Name"
    :show-dialog="showDialog"
    :on-close="handleClose"
    :on-primary="handleClose"
    primary-button-text="OK"
    :width="340"
  >
    <asc-duplicate-name :name="name"></asc-duplicate-name>
  </asc-dialog>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDuplicateName from '@/components/molecules/AscDuplicateName'
import AscDialog from '@/components/atoms/AscDialog'

export default {
  name: 'AscAddPlotToIssueDialog',

  components: {
    AscDuplicateName,
    AscDialog,
  },

  mixins: [AscDialogMixin],

  props: {
    name: {
      type: String,
      default: '',
    },
  },

  methods: {
    handleClose() {
      if (this.onClose) {
        this.onClose()
      }
    },
  },
}
</script>
